import React from 'react';
import { FaUsers, FaProjectDiagram, FaSun, FaEnvelope } from 'react-icons/fa';
// 1. Import CSS Module
import styles from './Admin.module.css';

const DashboardHome = () => {
  // Filhal ye Dummy Data hai, baad me API se aayega
  const stats = [
    { title: "Total Projects", count: "124", icon: <FaProjectDiagram />, color: "#3b82f6" },
    { title: "New Inquiries", count: "8", icon: <FaEnvelope />, color: "#f59e0b" },
    { title: "Power Gen (kW)", count: "5.4 MW", icon: <FaSun />, color: "#eab308" },
    { title: "Site Visitors", count: "1,204", icon: <FaUsers />, color: "#4ade80" },
  ];

  return (
    <div>
      {/* Stats Cards Grid */}
      <div className={styles.statsGrid}>
        {stats.map((stat, index) => (
          <div key={index} className={styles.statCard}>
            
            {/* Icon Circle */}
            <div 
              className={styles.statIcon} 
              style={{ color: stat.color, background: `${stat.color}20` }} // Dynamic color inline hi rahega
            >
              {stat.icon}
            </div>
            
            {/* Text Info */}
            <div className={styles.statInfo}>
              <h3>{stat.count}</h3>
              <p>{stat.title}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Welcome / Recent Activity Section */}
      {/* Hum 'formCard' class reuse kar rahe hain kyunki uska style (Glass effect) same hai */}
      <div className={styles.formCard} style={{ marginTop: '20px' }}>
        <h3 style={{ marginBottom: '15px', color: '#fff' }}>Welcome to Rengie Control Panel</h3>
        <p style={{ color: '#94a3b8', lineHeight: '1.6' }}>
          Select an option from the sidebar to manage your website content. <br />
          You can upload new project images in the <strong style={{color: '#4ade80'}}>Gallery</strong> section or change your password in the <strong style={{color: '#4ade80'}}>Settings</strong> section.
        </p>
      </div>
    </div>
  );
};

export default DashboardHome;